<template>
  <div>
  <el-card body-style="padding: 0">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">我邀请的商家</span>
    </div>

    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="queryForm.businessName" placeholder="请输入关键字"/>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="6">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :max-height="tableHeight"
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}">
      <el-table-column prop="businessId" label="用户ID" />
      <el-table-column prop="businessName" label="用户名" />
      <el-table-column prop="createTime" label="添加时间" />
      <el-table-column prop="money" label="余额" />
      <el-table-column prop="shopNums" label="店铺数" />
      <el-table-column prop="orderTotalNums" label="放单总数" />
      <el-table-column prop="remarks" label="备注" />
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {queryBusiness} from "@/api/b2cbusiness/b2c_saleman";
export default {
  name: "MyStoreRequestlist",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
      },
      tableHeight: 450,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      queryBusiness(this.queryForm, this.pagination).then(res => {
        console.log(res.data)
        if (res.success) {
          this.tableData = res.data.records;
          console.log(this.tableData)
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      })
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },

  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
